import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './i18n/i18n';
import { cargarTextos } from './i18n/overrides';
import App from './App';
import reportWebVitals from './reportWebVitals';

cargarTextos();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Suspense fallback={null}>
      <App />
    </Suspense>
  </React.StrictMode>
);

reportWebVitals();
